var {
  useProviderProps
} = require("@react-spectrum/provider");

var {
  useMessageFormatter
} = require("@react-aria/i18n");

var {
  filterDOMProps,
  mergeProps
} = require("@react-aria/utils");

var _spectrumIconsUiAsterisk = $parcel$interopDefault(require("@spectrum-icons/ui/Asterisk"));

var _babelRuntimeHelpersInteropRequireDefault = $parcel$interopDefault(require("@babel/runtime/helpers/interopRequireDefault"));

var _react = $parcel$interopDefault(require("react"));

var _spectrumIconsUiAlertMedium = $parcel$interopDefault(require("@spectrum-icons/ui/AlertMedium"));

var {
  Flex
} = require("@react-spectrum/layout");

var {
  classNames,
  useStyleProps,
  useDOMRef
} = require("@react-spectrum/utils");

var _babelRuntimeHelpersObjectWithoutPropertiesLoose = $parcel$interopDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/helptext/vars.css
var $b365e3c7bfe43a9b7fc4c2aa507$exports = {};
$b365e3c7bfe43a9b7fc4c2aa507$exports = {
  "spectrum-HelpText": "_spectrum-HelpText_9aee4",
  "spectrum-HelpText-validationIcon": "_spectrum-HelpText-validationIcon_9aee4",
  "spectrum-HelpText-text": "_spectrum-HelpText-text_9aee4",
  "spectrum-HelpText--neutral": "_spectrum-HelpText--neutral_9aee4",
  "is-disabled": "_is-disabled_9aee4",
  "spectrum-HelpText--negative": "_spectrum-HelpText--negative_9aee4"
};
var $b365e3c7bfe43a9b7fc4c2aa507$$interop$default = $parcel$interopDefault($b365e3c7bfe43a9b7fc4c2aa507$exports);

function $e85cbb92417300843dc593fb87e7f58a$var$HelpText(props, ref) {
  let {
    description,
    errorMessage,
    validationState,
    isDisabled,
    showErrorIcon,
    descriptionProps,
    errorMessageProps
  } = props;
  let domRef = useDOMRef(ref);
  let isErrorMessage = errorMessage && validationState === 'invalid';
  return /*#__PURE__*/_react.createElement("div", {
    className: classNames($b365e3c7bfe43a9b7fc4c2aa507$$interop$default, 'spectrum-HelpText', "spectrum-HelpText--" + (isErrorMessage ? 'negative' : 'neutral'), {
      'is-disabled': isDisabled
    }),
    ref: domRef
  }, isErrorMessage ? /*#__PURE__*/_react.createElement(_react.Fragment, null, showErrorIcon && /*#__PURE__*/_react.createElement(_spectrumIconsUiAlertMedium, {
    UNSAFE_className: classNames($b365e3c7bfe43a9b7fc4c2aa507$$interop$default, 'spectrum-HelpText-validationIcon')
  }), /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, errorMessageProps, {
    className: classNames($b365e3c7bfe43a9b7fc4c2aa507$$interop$default, 'spectrum-HelpText-text')
  }), errorMessage)) : /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, descriptionProps, {
    className: classNames($b365e3c7bfe43a9b7fc4c2aa507$$interop$default, 'spectrum-HelpText-text')
  }), description));
}
/**
 * Help text provides either an informative description or an error message that gives more context about what a user needs to input. It's commonly used in forms.
 */


const HelpText = /*#__PURE__*/_react.forwardRef($e85cbb92417300843dc593fb87e7f58a$var$HelpText);

exports.HelpText = HelpText;
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldlabel/vars.css
var $a0bedb1888ff92cb3407d1a60d76e$exports = {};
$a0bedb1888ff92cb3407d1a60d76e$exports = {
  "spectrum-FieldLabel": "_spectrum-FieldLabel_36b9b",
  "spectrum-FieldLabel--positionSide": "_spectrum-FieldLabel--positionSide_36b9b",
  "spectrum-FieldLabel-requiredIcon": "_spectrum-FieldLabel-requiredIcon_36b9b",
  "spectrum-FieldLabel--alignEnd": "_spectrum-FieldLabel--alignEnd_36b9b",
  "spectrum-Field": "_spectrum-Field_36b9b",
  "spectrum-Field--positionTop": "_spectrum-Field--positionTop_36b9b",
  "spectrum-Field-field": "_spectrum-Field-field_36b9b",
  "spectrum-Field-field--multiline": "_spectrum-Field-field--multiline_36b9b",
  "spectrum-Field--positionSide": "_spectrum-Field--positionSide_36b9b",
  "spectrum-Field-wrapper": "_spectrum-Field-wrapper_36b9b",
  "spectrum-Form": "_spectrum-Form_36b9b",
  "spectrum-Form--positionSide": "_spectrum-Form--positionSide_36b9b",
  "spectrum-Form--positionTop": "_spectrum-Form--positionTop_36b9b",
  "spectrum-Form-itemLabel": "_spectrum-Form-itemLabel_36b9b",
  "is-disabled": "_is-disabled_36b9b"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ar-AE.json
var $dba6f47c0633f1c62ae34bb5964884f$exports = {};
$dba6f47c0633f1c62ae34bb5964884f$exports = JSON.parse("{\"(optional)\":\"(اختياري)\",\"(required)\":\"(مطلوب)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/bg-BG.json
var $ec854bcc80a78bd74516e0a3a8b2b7$exports = {};
$ec854bcc80a78bd74516e0a3a8b2b7$exports = JSON.parse("{\"(optional)\":\"(незадължително)\",\"(required)\":\"(задължително)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/cs-CZ.json
var $f8483afc5cfa1f04e621a6293e6a96$exports = {};
$f8483afc5cfa1f04e621a6293e6a96$exports = JSON.parse("{\"(optional)\":\"(volitelně)\",\"(required)\":\"(požadováno)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/da-DK.json
var $e5b3827f2f03fadf1c016232dac0c3b2$exports = {};
$e5b3827f2f03fadf1c016232dac0c3b2$exports = JSON.parse("{\"(optional)\":\"(valgfrit)\",\"(required)\":\"(obligatorisk)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/de-DE.json
var $d0e804db48e4f5fde77f7104b72$exports = {};
$d0e804db48e4f5fde77f7104b72$exports = JSON.parse("{\"(optional)\":\"(optional)\",\"(required)\":\"(erforderlich)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/el-GR.json
var $f9c7b13da02b8927c419d06284d4b105$exports = {};
$f9c7b13da02b8927c419d06284d4b105$exports = JSON.parse("{\"(optional)\":\"(προαιρετικό)\",\"(required)\":\"(απαιτείται)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/en-US.json
var $dcdd35ccf2acfd323d25880f390$exports = {};
$dcdd35ccf2acfd323d25880f390$exports = JSON.parse("{\"(required)\":\"(required)\",\"(optional)\":\"(optional)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/es-ES.json
var $e0efc741764ef2896de49d44c289435$exports = {};
$e0efc741764ef2896de49d44c289435$exports = JSON.parse("{\"(optional)\":\"(opcional)\",\"(required)\":\"(necesario)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/et-EE.json
var $de127c611a61db2122448e80fd98fc13$exports = {};
$de127c611a61db2122448e80fd98fc13$exports = JSON.parse("{\"(optional)\":\"(valikuline)\",\"(required)\":\"(nõutav)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/fi-FI.json
var $cb38bd33362e0f0fe327c171c4eab9$exports = {};
$cb38bd33362e0f0fe327c171c4eab9$exports = JSON.parse("{\"(optional)\":\"(valinnainen)\",\"(required)\":\"(pakollinen)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/fr-FR.json
var $fcdbf24f0f4cf813342fda2f00ddda$exports = {};
$fcdbf24f0f4cf813342fda2f00ddda$exports = JSON.parse("{\"(optional)\":\"(facultatif)\",\"(required)\":\"(requis)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/he-IL.json
var $eda0a7f43e99b0c012b8567fc855dca$exports = {};
$eda0a7f43e99b0c012b8567fc855dca$exports = JSON.parse("{\"(optional)\":\"(אופציונלי)\",\"(required)\":\"(נדרש)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/hr-HR.json
var $ccf72352e8d12d5f6adacf7026672e22$exports = {};
$ccf72352e8d12d5f6adacf7026672e22$exports = JSON.parse("{\"(optional)\":\"(opcionalno)\",\"(required)\":\"(obvezno)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/hu-HU.json
var $f20e7b4ba50ff083ba5799d653b7725$exports = {};
$f20e7b4ba50ff083ba5799d653b7725$exports = JSON.parse("{\"(optional)\":\"(opcionális)\",\"(required)\":\"(kötelező)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/it-IT.json
var $f1bf56b9dfb5a809703ac27f6d3c0deb$exports = {};
$f1bf56b9dfb5a809703ac27f6d3c0deb$exports = JSON.parse("{\"(optional)\":\"(facoltativo)\",\"(required)\":\"(obbligatorio)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ja-JP.json
var $bdf130752329d55ead48593caac7801$exports = {};
$bdf130752329d55ead48593caac7801$exports = JSON.parse("{\"(optional)\":\"（オプション）\",\"(required)\":\"（必須）\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ko-KR.json
var $e5c67d9575fffdb1cd33c16ae40$exports = {};
$e5c67d9575fffdb1cd33c16ae40$exports = JSON.parse("{\"(optional)\":\"(선택 사항)\",\"(required)\":\"(필수 사항)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/lt-LT.json
var $d1dd6f8ede13eb746c519d1477de2$exports = {};
$d1dd6f8ede13eb746c519d1477de2$exports = JSON.parse("{\"(optional)\":\"(pasirenkama)\",\"(required)\":\"(privaloma)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/lv-LV.json
var $f0accca6f214ebdeb7bf90909101fc8f$exports = {};
$f0accca6f214ebdeb7bf90909101fc8f$exports = JSON.parse("{\"(optional)\":\"(neobligāti)\",\"(required)\":\"(obligāti)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/nb-NO.json
var $c1ebd04955fea44a089abdd2380dd159$exports = {};
$c1ebd04955fea44a089abdd2380dd159$exports = JSON.parse("{\"(optional)\":\"(valgfritt)\",\"(required)\":\"(obligatorisk)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/nl-NL.json
var $f56b3e79b42eab836e82b69f4ec9d2$exports = {};
$f56b3e79b42eab836e82b69f4ec9d2$exports = JSON.parse("{\"(optional)\":\"(optioneel)\",\"(required)\":\"(vereist)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/pl-PL.json
var $b57c6440c9dd3f974ec52c6fa08c67$exports = {};
$b57c6440c9dd3f974ec52c6fa08c67$exports = JSON.parse("{\"(optional)\":\"(opcjonalne)\",\"(required)\":\"(wymagane)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/pt-BR.json
var $c1d24552d510e3832c7efc9e6046a9d$exports = {};
$c1d24552d510e3832c7efc9e6046a9d$exports = JSON.parse("{\"(optional)\":\"(opcional)\",\"(required)\":\"(obrigatório)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/pt-PT.json
var $af5aa2c9128773e059f3725cb17e265$exports = {};
$af5aa2c9128773e059f3725cb17e265$exports = JSON.parse("{\"(optional)\":\"(opcional)\",\"(required)\":\"(obrigatório)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ro-RO.json
var $b5b96ca6a3bab0de882a15c596e3$exports = {};
$b5b96ca6a3bab0de882a15c596e3$exports = JSON.parse("{\"(optional)\":\"(opţional)\",\"(required)\":\"(obligatoriu)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ru-RU.json
var $c481e968c171059c1f6509044f1e$exports = {};
$c481e968c171059c1f6509044f1e$exports = JSON.parse("{\"(optional)\":\"(дополнительно)\",\"(required)\":\"(обязательно)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/sk-SK.json
var $b9bc30f30bbf8ceb886ab83972b240f$exports = {};
$b9bc30f30bbf8ceb886ab83972b240f$exports = JSON.parse("{\"(optional)\":\"(nepovinné)\",\"(required)\":\"(povinné)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/sl-SI.json
var $b4c770b8a90bd8ed63f7f4442924f1fe$exports = {};
$b4c770b8a90bd8ed63f7f4442924f1fe$exports = JSON.parse("{\"(optional)\":\"(opcijsko)\",\"(required)\":\"(obvezno)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/sr-SP.json
var $bee29b58f9dc42b347812a00ea03da32$exports = {};
$bee29b58f9dc42b347812a00ea03da32$exports = JSON.parse("{\"(optional)\":\"(opciono)\",\"(required)\":\"(obavezno)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/sv-SE.json
var $d9a29e08ea9a081b5ce6b0482244699$exports = {};
$d9a29e08ea9a081b5ce6b0482244699$exports = JSON.parse("{\"(optional)\":\"(valfritt)\",\"(required)\":\"(krävs)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/tr-TR.json
var $f42175c318d2185cedf2534c9b9076e4$exports = {};
$f42175c318d2185cedf2534c9b9076e4$exports = JSON.parse("{\"(optional)\":\"(isteğe bağlı)\",\"(required)\":\"(gerekli)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/uk-UA.json
var $de5f8b3e2620ea138a3d0d1724992$exports = {};
$de5f8b3e2620ea138a3d0d1724992$exports = JSON.parse("{\"(optional)\":\"(необов’язково)\",\"(required)\":\"(обов’язково)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/zh-CN.json
var $acffc3b92a263a2c319dbb25be8dee24$exports = {};
$acffc3b92a263a2c319dbb25be8dee24$exports = JSON.parse("{\"(optional)\":\"（可选）\",\"(required)\":\"（必填）\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/zh-TW.json
var $d9e3772f23760bf9da6d02b8653c1bd5$exports = {};
$d9e3772f23760bf9da6d02b8653c1bd5$exports = JSON.parse("{\"(optional)\":\"(選填)\",\"(required)\":\"(必填)\"}");
// @ts-ignore
const $cd06bbbaaaccc13eaa9045c$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($dba6f47c0633f1c62ae34bb5964884f$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($ec854bcc80a78bd74516e0a3a8b2b7$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($f8483afc5cfa1f04e621a6293e6a96$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($e5b3827f2f03fadf1c016232dac0c3b2$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($d0e804db48e4f5fde77f7104b72$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($f9c7b13da02b8927c419d06284d4b105$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($dcdd35ccf2acfd323d25880f390$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($e0efc741764ef2896de49d44c289435$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($de127c611a61db2122448e80fd98fc13$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($cb38bd33362e0f0fe327c171c4eab9$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($fcdbf24f0f4cf813342fda2f00ddda$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($eda0a7f43e99b0c012b8567fc855dca$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($ccf72352e8d12d5f6adacf7026672e22$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($f20e7b4ba50ff083ba5799d653b7725$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($f1bf56b9dfb5a809703ac27f6d3c0deb$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($bdf130752329d55ead48593caac7801$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($e5c67d9575fffdb1cd33c16ae40$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($d1dd6f8ede13eb746c519d1477de2$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($f0accca6f214ebdeb7bf90909101fc8f$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($c1ebd04955fea44a089abdd2380dd159$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($f56b3e79b42eab836e82b69f4ec9d2$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($b57c6440c9dd3f974ec52c6fa08c67$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($c1d24552d510e3832c7efc9e6046a9d$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($af5aa2c9128773e059f3725cb17e265$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($b5b96ca6a3bab0de882a15c596e3$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($c481e968c171059c1f6509044f1e$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($b9bc30f30bbf8ceb886ab83972b240f$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($b4c770b8a90bd8ed63f7f4442924f1fe$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($bee29b58f9dc42b347812a00ea03da32$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($d9a29e08ea9a081b5ce6b0482244699$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($f42175c318d2185cedf2534c9b9076e4$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($de5f8b3e2620ea138a3d0d1724992$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($acffc3b92a263a2c319dbb25be8dee24$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($d9e3772f23760bf9da6d02b8653c1bd5$exports).default
};
var $a0bedb1888ff92cb3407d1a60d76e$$interop$default = $parcel$interopDefault($a0bedb1888ff92cb3407d1a60d76e$exports);

function $cd06bbbaaaccc13eaa9045c$var$Label(props, ref) {
  props = useProviderProps(props);

  let {
    children,
    labelPosition = 'top',
    labelAlign = labelPosition === 'side' ? 'start' : null,
    isRequired,
    necessityIndicator = isRequired != null ? 'icon' : null,
    includeNecessityIndicatorInAccessibilityName = false,
    htmlFor,
    for: labelFor,
    elementType: ElementType = 'label',
    onClick
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["children", "labelPosition", "labelAlign", "isRequired", "necessityIndicator", "includeNecessityIndicatorInAccessibilityName", "htmlFor", "for", "elementType", "onClick"]);

  let domRef = useDOMRef(ref);
  let {
    styleProps
  } = useStyleProps(otherProps);
  let formatMessage = useMessageFormatter($cd06bbbaaaccc13eaa9045c$var$intlMessages);
  let necessityLabel = isRequired ? formatMessage('(required)') : formatMessage('(optional)');

  let icon = /*#__PURE__*/_react.createElement(_spectrumIconsUiAsterisk, {
    UNSAFE_className: classNames($a0bedb1888ff92cb3407d1a60d76e$$interop$default, 'spectrum-FieldLabel-requiredIcon'),
    "aria-label": includeNecessityIndicatorInAccessibilityName ? formatMessage('(required)') : undefined
  });

  let labelClassNames = classNames($a0bedb1888ff92cb3407d1a60d76e$$interop$default, 'spectrum-FieldLabel', {
    'spectrum-FieldLabel--positionSide': labelPosition === 'side',
    'spectrum-FieldLabel--alignEnd': labelAlign === 'end'
  }, styleProps.className);
  return /*#__PURE__*/_react.createElement(ElementType, _babelRuntimeHelpersExtends({}, filterDOMProps(otherProps), styleProps, {
    onClick: onClick,
    ref: domRef,
    className: labelClassNames,
    htmlFor: ElementType === 'label' ? labelFor || htmlFor : undefined
  }), children, (necessityIndicator === 'label' || necessityIndicator === 'icon' && isRequired) && ' \u200b', necessityIndicator === 'label' && /*#__PURE__*/_react.createElement("span", {
    "aria-hidden": !includeNecessityIndicatorInAccessibilityName ? isRequired : undefined
  }, necessityLabel), necessityIndicator === 'icon' && isRequired && icon);
}

let Label = /*#__PURE__*/_react.forwardRef($cd06bbbaaaccc13eaa9045c$var$Label);

exports.Label = Label;

function $d2ecd00afec46f6300dcc47dcdc8$var$Field(props, ref) {
  let {
    label,
    labelPosition = 'top',
    labelAlign,
    isRequired,
    necessityIndicator,
    includeNecessityIndicatorInAccessibilityName,
    validationState,
    description,
    errorMessage,
    isDisabled,
    showErrorIcon,
    children,
    labelProps,
    // Not every component that uses <Field> supports help text.
    descriptionProps = {},
    errorMessageProps = {},
    elementType,
    wrapperClassName
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["label", "labelPosition", "labelAlign", "isRequired", "necessityIndicator", "includeNecessityIndicatorInAccessibilityName", "validationState", "description", "errorMessage", "isDisabled", "showErrorIcon", "children", "labelProps", "descriptionProps", "errorMessageProps", "elementType", "wrapperClassName"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let hasHelpText = !!description || errorMessage && validationState === 'invalid';

  if (label || hasHelpText) {
    let labelWrapperClass = classNames($a0bedb1888ff92cb3407d1a60d76e$$interop$default, 'spectrum-Field', {
      'spectrum-Field--positionTop': labelPosition === 'top',
      'spectrum-Field--positionSide': labelPosition === 'side'
    }, styleProps.className, wrapperClassName);
    children = /*#__PURE__*/_react.cloneElement(children, mergeProps(children.props, {
      className: classNames($a0bedb1888ff92cb3407d1a60d76e$$interop$default, 'spectrum-Field-field')
    }));

    let renderHelpText = () => /*#__PURE__*/_react.createElement(HelpText, {
      descriptionProps: descriptionProps,
      errorMessageProps: errorMessageProps,
      description: description,
      errorMessage: errorMessage,
      validationState: validationState,
      isDisabled: isDisabled,
      showErrorIcon: showErrorIcon
    });

    let renderChildren = () => {
      if (hasHelpText) {
        if (labelPosition === 'side') {
          return /*#__PURE__*/_react.createElement(Flex, {
            direction: "column",
            UNSAFE_className: classNames($a0bedb1888ff92cb3407d1a60d76e$$interop$default, 'spectrum-Field-wrapper')
          }, children, renderHelpText());
        }

        return /*#__PURE__*/_react.createElement(_react.Fragment, null, children, renderHelpText());
      }

      return children;
    };

    return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, styleProps, {
      ref: ref,
      className: labelWrapperClass
    }), label && /*#__PURE__*/_react.createElement(Label, _babelRuntimeHelpersExtends({}, labelProps, {
      labelPosition: labelPosition,
      labelAlign: labelAlign,
      isRequired: isRequired,
      necessityIndicator: necessityIndicator,
      includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName,
      elementType: elementType
    }), label), renderChildren());
  }

  return /*#__PURE__*/_react.cloneElement(children, mergeProps(children.props, _babelRuntimeHelpersExtends({}, styleProps, {
    ref
  })));
}

let Field = /*#__PURE__*/_react.forwardRef($d2ecd00afec46f6300dcc47dcdc8$var$Field);

exports.Field = Field;
